import React, { Component } from 'react';
import classNames from 'classnames';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Checkout from './Checkout';
import TargetTab from './TargetTab';
// import PaymentTab from './PaymentTab';
// import ScheduleTab from './ScheduleTab';
import DateAndTime from '../micro/DateTime';
import SelectEvent from '../micro/SelectEvent';

import FacebookPost from './previews/FacebookPost';

const PaymentTab = ({
  state,
  handleChange,
  showCheckout,
}) => {
  function onChange(ev) {
    console.log(ev.target.value);
  }
  return (
    <div> 
      <input className="input" type="text" 
        placeholder="Order Name"
        name="orderName"
        value={state.orderName}
        onChange={handleChange}/>
      <div className="columns">
        <div className="column">
          <label className="label">
            {/* Send Date */}
            <DateAndTime className="input" 
              placeholder="Start Date/Time"
              name="startDateTime"
              value={state.startDateTime}
              handleChange={handleChange} />
          </label>
        </div>
        <div className="column">
          <label className="label">
            {/* Event Date */}
            <DateAndTime className="input" 
              placeholder="End Date/Time"
              name="endDateTime"
              value={state.endDateTime}
              handleChange={handleChange} />
          </label>
        </div>
      </div>

      <div className="checkout__item flex-between">
        <div className="checkout__label">Available Fans</div>
        <div className="checkout__number">{(2032434).toLocaleString('en')}</div>
      </div>
      <div className="checkout__item flex-between">
        <div className="checkout__label">Cost Per Contact</div>
        <div className="checkout__number">$0.50</div>
      </div>
      <div className="checkout__item flex-between">
        <div className="checkout__label">Campaign Estimated Reach</div>
        <input className="checkout__input" type="number" min="3000" max="2032434"
          placeholder="3000"
          name="quantity"
          value={state.quantity}
          onChange={handleChange}/>
      </div>
      <hr className="checkout__hr"/>
      {
        state.quantity &&
        <div className="checkout__item flex-between">
          <div className="checkout__label">Audience Cost</div>
          <div className="checkout__number checkout__total"><b>${Math.round(state.quantity * 0.50).toLocaleString('en')}</b></div>
        </div>
      }
      <button className="button checkout__button" 
        onClick={showCheckout}>
        { state.checkout ? 'Edit Order' : 'Proceed To Checkout' }
      </button>
    </div>
  )
}

class SocialCampaign extends Component {
  state = {
    message: 'Post message',
    url: '',
    title: '',
    descr: '',
    image: null,
    country: '',
    city: '',
    segment: '',
    orderName: '',
    sendDate: '',
    eventDate: '',
    startDateTime: '',
    endDateTime: '',
    isMobile: false,
    checkout: false,
  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({ [name]: value })
  }

  handleImage = (ev) => {
    const file = ev.target.files[0];
    console.log(file);
    if (file) {
      const url = window.URL.createObjectURL(file);
      this.setState({ image: url })
    }
    ev.target.value = '';
  }

  removeImage = (ev) => {
    this.setState({image: null});
  }

  showCheckout = (ev) => {
    this.setState({ checkout: !this.state.checkout })
  }

  toggleMobilePreview = (ev) => {
    this.setState({ isMobile: !this.state.isMobile })
  }

  render() {
    const campaign__sidebar = classNames('campaign__sidebar', { 'campaign__sidebar--disable': this.state.checkout });
    return (
      <div className="campaign">
        <div className={campaign__sidebar}>
          <Tabs>
            <TabList className="campaign__tabs">
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Facebook Campaign</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Target</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Order</Tab>
            </TabList>
            <TabPanel>
              <SelectEvent />
              <textarea className="textarea" rows="4" 
                placeholder="Message"
                name="message"
                value={this.state.message}
                onChange={this.handleChange}/>
              <input className="input" type="text" 
                placeholder="URL"
                name="url"
                value={this.state.url}
                onChange={this.handleChange} />
              <input className="input" type="text"
                { ...( !this.state.url && { disabled: true } ) } 
                placeholder="Headline"
                name="title"
                value={this.state.title}
                onChange={this.handleChange} />
              <textarea className="textarea" rows="4" 
                { ...( !this.state.url && { disabled: true } ) } 
                placeholder="Description"
                name="descr"
                value={this.state.descr}
                onChange={this.handleChange}/>
              <div className="flex">
                <label className="file">
                  Select image
                  <input type="file" 
                    name="image"
                    onChange={this.handleImage} />
                </label>
                { this.state.image && 
                  <div className="file__remove" onClick={this.removeImage}>×</div> 
                }
              </div>
            </TabPanel>
            <TabPanel>
              <TargetTab 
                state={this.state}
                handleChange={this.handleChange} />
            </TabPanel>
            <TabPanel>
              <PaymentTab 
                state={this.state}
                handleChange={this.handleChange} 
                showCheckout={this.showCheckout} />
            </TabPanel>
          </Tabs>
          {/* <div className="campaign__buttons">
            <button className="button" onClick={this.props.hideModal}>Close</button>
            <button className="button">Save</button>
          </div> */}
        </div>
        <div className="campaign__preview fbpost__bg">
          
          { this.state.checkout ? 
            <Checkout /> :
            [
              <div className="campaign__preview-btn" key={0}
                onClick={this.toggleMobilePreview}>
                { this.state.isMobile ? 'Desktop' : 'Mobile' }
              </div>,
              <FacebookPost key={1}
                image={this.state.image}
                message={this.state.message}
                title={this.state.title}
                descr={this.state.descr}
                url={this.state.url}
                isMobile={this.state.isMobile}
              />
            ]
          }
        </div>
      </div>
    );
  }
}

export default SocialCampaign;


// WEBPACK FOOTER //
// ./src/components/campaigns/SocialCampaign.js